import React, { useState } from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { uploadFileApi, markWeeklyWithdrawalPaidApi, changePartnerEarningWithdrawRequestStatusApi, markPaidrewardWithdrawalApi } from "../../../utils/ApiEndpointFunctions";
import { convertByteToMB } from "../../../utils/HelperFuncitons";
import Spinwheel from "../../common/Spinwheel";
import { S3_URL } from "../../../utils/BaseUrl";
import { weeklyMarkPaidInitialValues, weeklyMarkPaidValidationSchema } from "../Validation";

const FILE_ACCEPT = ["image/png", "image/jpeg", "image/jpg"];

const WeeklyMarkPaidModal = ({ selectedWithdrawal, onSuccess,type }) => {
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState(0);

  console.log('type',type);

  const formik = useFormik({
    initialValues: weeklyMarkPaidInitialValues,
    validationSchema: weeklyMarkPaidValidationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        let res;
        if (type === "weekly") {
          res = await markWeeklyWithdrawalPaidApi(values);
        } else if (type === "reward") {
          res = await markPaidrewardWithdrawalApi(values);
        } else {
          res = await changePartnerEarningWithdrawRequestStatusApi(values);
        }
        if (res.status === 200) {
          toast.success(res.data?.message || "Marked as paid");
          document.getElementById("closeWeeklyPaidModal").click();
          onSuccess?.();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  // React.useEffect(() => {
  //   if (selectedWithdrawal?.id) {
  //     formik.setFieldValue("id", selectedWithdrawal.id);
  //   }
  // }, [selectedWithdrawal]);

  React.useEffect(() => {
    if (!selectedWithdrawal?.id) return;
    formik.setValues({
      id: selectedWithdrawal.id,
      transactionId: "",
      mode: "",
      status: "pending",
      attachment: "",
    });
    setKey(k => k + 1);
  }, [selectedWithdrawal?.id]);



  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!FILE_ACCEPT.includes(file.type)) {
      return toast.error("Only JPG / PNG allowed");
    }

    if (convertByteToMB(file.size) > 5) {
      return toast.error("Max file size is 5MB");
    }

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "type",
        type === "weekly"
          ? "weekly-withdrawal"
          : type === "reward"
            ? "reward-withdrawal"
            : "instant-withdrawal"
      );

      const res = await uploadFileApi(formData);
      if (res.status === 200 && res.data?.status === 1) {
        toast.success("Attachment uploaded");
        formik.setFieldValue("attachment", res.data.data);
      }
    } catch {
      toast.error("File upload failed");
    }
  };

  const removeImage = () => {
    setKey((k) => k + 1);
    formik.setFieldValue("attachment", "");
  };

  return (
    <div className="modal fade" id="weeklyPaidModal" tabIndex="-1">
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-header">
              <h2 className="modal-title">Mark As Paid</h2>
              <button
                type="button"
                className="btn-close"
                id="closeWeeklyPaidModal"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">
              <div className="mb-2">
                <label>Status</label>
                <select
                  className="form-control"
                  name="status"
                  value={formik.values.status}
                  onChange={formik.handleChange}
                >
                  <option value="pending">Pending</option>
                  <option value="paid">Paid</option>
                </select>
              </div>
              {formik.errors.status && (
                  <small className="text-danger">
                    {formik.errors.status}
                  </small>
                )}

              <div className="mb-2">
                <label>Payment Mode</label>
                <select
                  className="form-control"
                  name="mode"
                  value={formik.values.mode}
                  onChange={formik.handleChange}
                >
                  <option value="">Select Mode</option>
                  <option value="online">Online</option>
                  {/* <option value="BANK">Bank Transfer</option>
                  <option value="CASH">Cash</option> */}
                </select>
                {formik.touched.mode && formik.errors.mode && (
                  <small className="text-danger">{formik.errors.mode}</small>
                )}
              </div>

              <div className="mb-2">
                <label>Transaction ID</label>
                <input
                  type="text"
                  className="form-control"
                  name="transactionId"
                  value={formik.values.transactionId}
                  onChange={formik.handleChange}
                />
                 {formik.touched.transactionId && formik.errors.transactionId && (
                  <small className="text-danger">
                    {formik.errors.transactionId}
                  </small>
                )}
              </div>

              <div className="mb-3">
                <label>Attachment</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/png,image/jpeg,image/jpg"
                  onChange={handleFileUpload}
                />
                {formik.touched.attachment && (
                  <small className="text-danger">
                    {formik.errors.attachment}
                  </small>
                )}
                {formik.values.attachment && (
                  <div className="mt-2 position-relative">
                    <img
                      src={`${S3_URL}/${formik.values.attachment}`}
                      alt="attachment"
                      className="img-fluid rounded"
                    />
                    <span
                      className="position-absolute text-danger"
                      style={{ top: 5, right: 10, cursor: "pointer" }}
                      onClick={removeImage}
                    >
                      ✕
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer mt-0 pt-0">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? <Spinwheel /> : "Confirm"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WeeklyMarkPaidModal;
